import { AutoComplete, AutoCompleteProps, Input } from 'antd'
import { BaseOptionType, DefaultOptionType, RefSelectProps } from 'antd/lib/select'
import React, { ForwardedRef, useState } from 'react'

import { CloseIcon, SearchIcon } from '../../icons'
import { Wrapper } from './styles'

export interface ISearchBarProps extends AutoCompleteProps<any, BaseOptionType | DefaultOptionType> {
  placeholder?: string
}

const SearchBar = React.forwardRef<RefSelectProps, ISearchBarProps>(
  (props: ISearchBarProps, ref: ForwardedRef<RefSelectProps>) => {
    const [isEmpty, setIsEmpty] = useState<boolean>(props.value === undefined && props.defaultValue === undefined)
    const [valueLength, setValueLength] = useState<number>(
      (props.value?.label?.length ||
        props.value?.value?.length ||
        props.value?.length ||
        props.defaultValue?.label?.length ||
        props.defaultValue?.value?.length ||
        props.defaultValue?.length ||
        1) + 2,
    )

    const onChangeProxy = (
      value: any,
      option: BaseOptionType | DefaultOptionType | (BaseOptionType | DefaultOptionType)[],
    ) => {
      if (value && value !== '') {
        setIsEmpty(false)
        setValueLength(value.length + 2)
      } else {
        setIsEmpty(true)
        setValueLength(3)
      }
      props.onChange && props.onChange(value, option)
    }

    const defaultAutoCompleteProps = {
      listHeight: 300,
      listItemHeight: 32,
      getPopupContainer: (triggerNode: any) => {
        return triggerNode.parentNode as HTMLElement
      },
      allowClear: { clearIcon: <CloseIcon /> },
      popupMatchSelectWidth: false,
    }

    const autoCompleteProps = { ...defaultAutoCompleteProps, ...props, placeholder: undefined, onChange: onChangeProxy }

    return (
      <Wrapper id="nova-shared-Search-Bar-root" isEmpty={isEmpty}>
        <AutoComplete {...autoCompleteProps} ref={ref}>
          <Input suffix={isEmpty ? <SearchIcon /> : <span />} placeholder={props.placeholder} htmlSize={valueLength} />
        </AutoComplete>
      </Wrapper>
    )
  },
)

SearchBar.displayName = 'SearchBar'
export default SearchBar
